import React from "react";

export const Navigation = (props) => {
  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            {" "}
            <span className="sr-only">Toggle navigation</span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
            <span className="icon-bar"></span>{" "}
          </button>
          <a className="navbar-brand page-scroll" href="#page-top">
            Dome Technologies
          </a>{" "}
        </div>

        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right">
            <li>
              <a href="#about" className="page-scroll" >
                About US
              </a>
            </li>
            <li>
              <a href="#solutions" className="page-scroll">
               Solutions 
              </a>
            </li>
            <li>
              <a href="#infrastructure" className="page-scroll">
              IT Infrastructure
              </a>
            </li>
            <li>
              <a href="#media" className="page-scroll">
               Media Productions 
              </a>
            </li>
            <li>
              <a href="#partners" className="page-scroll">
              Our Partners 
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};
